import { FC } from "react";
import { OnboardingRouter } from "@/components/onboarding/OnboardingRouter";
import { InterstitialOverlay } from "@/components/overlay";
import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";

export const OnboardingOverlay: FC = observer(() => {
  const { store } = useAppStore();

  return (
    <InterstitialOverlay isOpen={!store.platformInfo.onboardingInfo.onboardingIsCompleted}>
      <OnboardingRouter />
    </InterstitialOverlay>
  );
});
